function parentFocus()
{
  $('.js-child-focus').focus(function () {
    $(this).closest('.js-parent-focus').addClass('focus');
  });
  $('.js-child-focus').focusout(function () {
    $(this).closest('.js-parent-focus').removeClass('focus');
  });
}

function togglePasswordVisibility()
{
  $('button[data-action="show-password"]').on('click', function () {
    var elm = $(this).closest('.input-group').children('input.js-visible-password');
    if (elm.attr('type') === 'password') {
      elm.attr('type', 'text');
      $(this).find('.fa').removeClass($(this).data('show')).addClass($(this).data('hide'));
    } else {
      elm.attr('type', 'password');
      $(this).find('.fa').removeClass($(this).data('hide')).addClass($(this).data('show'));
    }
  });
}

function makeJSForm()
{
  togglePasswordVisibility();
}

$(document).ready(function() {
  makeJSForm();
});
